var packageName = "@atlassian/switcher";
var packageVersion = "38.2.6";
export default {
  packageName: packageName,
  packageVersion: packageVersion
};